import { RiskType } from '@/models';

function getRiskTypeByValue(value: number, comparison = ''): RiskType {
  if (!!comparison) {
    if (comparison === '>') {
      return 'danger';
    }
    return 'trusted';
  }

  if (value >= 75) {
    return 'danger';
  }

  if (value > 25) {
    return 'suspicious';
  }

  return 'trusted';
}

export default getRiskTypeByValue;
